import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import { AlertTriangle, X, Trash2 } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { AnimatedIconButton } from './AnimatedIconButton';

interface DeleteConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
}

export function DeleteConfirmModal({ open, onClose, onConfirm, title, description }: DeleteConfirmModalProps) {
  const { t } = useLanguage();
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md backdrop-blur-sm" style={{ backgroundColor: 'rgba(var(--color-background-rgb, 255, 255, 255), 0.9)' }}>
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <DialogDescription className="sr-only">{description}</DialogDescription>
        
        <div className="flex flex-col items-center gap-4 py-6 px-6">
          <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: 'var(--color-danger-light)' }}>
            <AlertTriangle className="w-6 h-6" style={{ color: 'var(--color-danger)' }} />
          </div>
          
          <div className="text-center">
            <h3 className="mb-2" style={{ color: 'var(--color-text-primary)' }}>{title}</h3>
            <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>{description}</p>
          </div>
          
          <div className="flex gap-3 justify-center mt-2">
            <AnimatedIconButton
              icon={X}
              label={t.common.cancel}
              onClick={onClose}
              variant="secondary"
              revealLabelOnHover={false}
            />
            <AnimatedIconButton
              icon={Trash2}
              label={t.common.delete}
              onClick={handleConfirm}
              variant="danger"
              revealLabelOnHover={false}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}